"use strict";
import 'babel-polyfill';
import React from "react";
import {loaderFactory, resolvers, templates, injector, types, tutils, PropTypes} from "Subschema";
import Styles from "./style";
import Templates from "./templates";
import Validators from "./validators";
import UIPropTypes from "./PropTypes";
import Anchor from "./types/anchor/Anchor.jsx";
import SkipLink from "./types/skipLinks/SkipLink.jsx";
import MaskedInput from "react-maskedinput";
import CreditTerms from "./types/credit/Terms.jsx";
import Busy from "./types/busy/Busy.jsx";
import RestrictedInput from "./types/restrictedInput/RestrictedInput.jsx";
import CapitalInput from "./types/input/CapitalInput.jsx";
import MultiFormatInput from "./types/input/MultiFormatInput.jsx";
import BankLoader from "./types/bank";
import CardLoader from "./types/card";
import FloatingLabel from "./labels/FloatingLabel.jsx";
import FloatingLabelLess from "./labels/FloatingLabel.less";
import RadioTemplate from "./templates/RadioTemplate";
import EditTemplate from "./templates/EditTemplate.jsx";
import BGAsset from "./templates/BGAsset.jsx";
import ActivationHeader from "./templates/ActivationHeader.jsx";
import StyledContent from "./templates/StyledContent.jsx";
import Address from "./schemas/Address.json";
import prefill from "./resolver/prefill";
import defaultValue from "./resolver/defaultValue";
import notif from "./resolver/notif";
import submit from "./resolver/submit";
import SsnNine from "./types/credit/SsnNine"

class PlainHidden extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        value: PropTypes.any
    };

    render() {
        const {content, ...props} = this.props;
        return <input type="hidden" {...props}/>
    }
}

const loader = loaderFactory();
loader.addSchema({Address});
loader.addLoader(BankLoader);
loader.addLoader(CardLoader);
loader.addStyle(Styles);
loader.addType({
    Anchor,
    SkipLink,
    BGAsset,
    ActivationHeader,
    MaskedInput,
    Busy,
    StyledContent,
    CreditTerms,
    PlainHidden,
    RestrictedInput,
    CapitalInput,
    MultiFormatInput,
    SsnNine
});

loader.addValidator(Validators);
loader.addTemplate({
    ...Templates,
    EditorTemplate: FloatingLabel,
    Busy,
    ButtonTemplate: SkipLink
});

injector.resolver(UIPropTypes.prefill, prefill);
injector.resolver(UIPropTypes.defaultValue, defaultValue);
injector.resolver(UIPropTypes.notif, notif);
injector.resolver(PropTypes.submit, submit);


templates.CheckboxTemplate.injectedPropTypes = {
    "label": "title"
};
types.Checkbox.template = {
    template: "CheckboxTemplate",
    className: "checkbox"
};

types.Select.template = {
    className: FloatingLabelLess.select
};

types.Password.injectedPropTypes = {
    onBlur: 'changeValidate'
};

types.Radio.template = RadioTemplate;
types.Radio.propTypes.defaultValue = UIPropTypes.defaultValue;

types.Content.template = false;

//This adds new propTypes to all types
resolvers.type.defaultPropTypes.disabled = PropTypes.bool;
resolvers.type.defaultPropTypes.autoFocus = PropTypes.bool;
resolvers.type.defaultPropTypes.prefill = UIPropTypes.prefill;
resolvers.type.defaultPropTypes.successClass = PropTypes.string;
resolvers.type.defaultPropTypes.autoComplete = PropTypes.string;
resolvers.type.defaultPropTypes.autoCorrect = PropTypes.string;
resolvers.type.defaultPropTypes.autoCapitalize = PropTypes.string;

// ToDO: Warning: this is for addressing a subschema bug in fieldAttrs
// ToDo: remove this after the bug is fixed
resolvers.type.defaultPropTypes.fieldAttrs = PropTypes.any;

//Adding resolvers to specific types/templates;
EditTemplate.propTypes.prefill = UIPropTypes.prefill;
types.Hidden.propTypes.defaultValue = UIPropTypes.defaultValue;
types.Hidden.propTypes.value = PropTypes.value;
types.Hidden.propTypes.prefill = UIPropTypes.prefill;
types.Select.propTypes.defaultValue = UIPropTypes.defaultValue;
(types.Text.propTypes || (types.Text.propTypes = {})).prefill = UIPropTypes.prefill;

export default loader;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/